<template>
  <v-radio-group
    :row="showGroupInRow"
    :disabled="disabled"
    class="radio"
    :class="{
      mixed
    }"
    v-model="value"
    :error-messages="errorMessages"
  >
    <div
      class="radio--standard"
      @click="setValue(option.value)"
      :class="{
        'radio--standard__active': value === option.value,
        mixed,
        withSublabel
      }"
      v-for="(option, index) in options"
      :key="`opt-${index}`"
    >
      <v-radio
        :label="option.label"
        :value="option.value"
        :ripple="false"
        color="white"
      >
        <template v-slot:label v-if="withSublabel">
          <h6>{{ option.title }}</h6>
          {{ option.label }}
        </template>
      </v-radio>
    </div>
  </v-radio-group>
</template>

<script>
export default {
  props: {
    /**
     * Array of objects containing the label and values
     * [{
     *  value,
     *  label
     * }]
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Default selected value
     */
    selectedValue: {
      type: [String, Number, Object, Array, Boolean],
      required: false,
      default: null
    },
    /**
     * Boolean to display in row
     */
    showGroupInRow: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: Boolean,
    errorMessages: [String, Array],
    mixed: {
      type: Boolean,
      default: false
    },
    withSublabel: Boolean
  },
  data() {
    return {
      value: this.selectedValue,
      darker: this.isDarker
    };
  },
  methods: {
    setValue(value) {
      this.$emit("select", value);
      this.value = value;
    }
  },
  watch: {
    selectedValue(newValue) {
      this.value = newValue;
    }
  }
};
</script>

<style lang="scss">
.withSublabel {
  label {
    display: block !important;
  }
}
</style>
